module.exports = __webpack_public_path__ + "static/Visual-81f1b24c94b76e79d2f381b4ad0fc877.png";